import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

interface OrderParameter {
    orderNumber: string;
    orderDate?: string;
    expand?: ("orderLines" | "shipments" | "vmidetails")[];
}

type HandlerType = typeof PopulateApiParameter;

export const PopulateApiParameterExtended: HandlerType = props => {
    const parameter = props.parameter as OrderParameter;

    props.apiParameter = {
        orderNumber: parameter.orderNumber,
        expand: parameter.expand ?? ["orderLines", "shipments"],
        additionalQueryStringParameters: {
            orderDate: parameter.orderDate,
        },
    } as GetOrderApiParameter;
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
